import React, {useEffect, useState} from 'react'
import {getGrantTypes, getScholarshipTree, removeGrantTypes, getGrantsYears} from '../../../actions/grants';
import {connect, useDispatch, useSelector} from 'react-redux';
import styles from './index.module.css'
import ReactLoader from 'react-loader';
import AddGrantType from '../AddGrantType';
import {FaTrash} from 'react-icons/fa6';
import Confirmation from '../../../assets/Confirmation/Confirmation';
import SettingsGrant from '../SettingsGrant';
import GrantThree from '../GrantThree';
import Selector from '../../shared/Selector';
import moment from 'moment';
const mapStateToProps = ({grants}) => {
    const {grant_types_loading, grant_types} = grants
    return {grant_types_loading, grant_types}
}
const Index = ({getGrantTypes, removeGrantTypes, grant_types_loading, grant_types, getGrantsYears}) => {

    const dispatch = useDispatch();

    const [isAddGrantsType,
        setIsAddGrantsType] = useState(false); // отображение попапа добавления типа грантов
    const [confirmation,
        setConfirmation] = useState(null); // отображение попапа подтверждения удаления записи
    const [editId,
        setEditId] = useState(null); // отображение попапа подтверждения удаления записи

    const [yearsLocal,
        setYearsLocal] = useState([]);
    const [year,
        setYear] = useState(null);

    const { years } = useSelector(
        (state) => state.grants
      );

    const acceptConfirmation = () => {
        removeGrantTypes(confirmation);
        setConfirmation(null);
    };

    const rejectConfirmation = () => {
        setConfirmation(null);
    };

    useEffect(() => {
        getGrantsYears();
        getGrantTypes();
    }, [])

    useEffect(() => {
        if (!years) {
            return
        }
        const newYears = years
            ?.map(({name, xp_key}) => ({name, value: xp_key})).reverse()
        setYearsLocal([...newYears])
    }, [years])

    useEffect(() => {
        if (!yearsLocal || yearsLocal
            ?.length === 0) {
            return
        }
        const yearNow = moment()
            .year()
            .toString();
        const yearCurrent = yearsLocal
            ?.find((val) => val.name.startsWith(yearNow))
                .value
                .toString();
        setYear(yearCurrent || '0')
    }, [yearsLocal])

    useEffect(() => {
        if (year == '0' || !year) {
            return
        }
        dispatch(getScholarshipTree(year));
    }, [year])

    return (
        <div>
            <h1 className={styles.title}>Типы Стипендий</h1>

            <div className={styles.buttonWrapper}>

                <Selector
                    label='Учебный год'
                    width='300px'
                    options={[...yearsLocal]}
                    onChange={(e) => setYear(e)}
                    value={year}/>

                <div className={styles.button} onClick={() => setIsAddGrantsType(true)}>Добавить вид стипендии</div>

            </div>

            {confirmation && (<Confirmation
                top="30px"
                left="40px"
                title="Уверены что хотите удалить запись?"
                acceptConfirmation={acceptConfirmation}
                rejectConfirmation={rejectConfirmation}/>)}

            {editId && <SettingsGrant setIsPopup={setEditId} id={editId}/>}

            {isAddGrantsType && <AddGrantType setIsPopup={setIsAddGrantsType}/>}

            {grant_types_loading && <ReactLoader/>}

            <GrantThree year__={year}/>

            <table className={styles.table}>
                <thead>
                    <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Название</th>
                        <th scope="col">Редактируемый</th>
                        <th scope="col">Удалить</th>
                    </tr>
                </thead>
                <tbody>
                    {grant_types.map((el) => (
                        <tr key={el.id}>
                            <th onClick={() => setEditId(el.id)}>{el.id}</th>
                            <td onClick={() => setEditId(el.id)}>{el.name}</td>
                            <td onClick={() => setEditId(el.id)}>{el.is_editable
                                    ? 'Да'
                                    : 'Нет'}</td>
                            <td>
                                <i onClick={() => setConfirmation(el.id)} className={styles.icon_delete}><FaTrash/></i>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {!grant_types_loading && !grant_types.length && <p className={styles.empty}>Нет данных</p>}

        </div>
    )
}

export default connect(mapStateToProps, {getGrantTypes, removeGrantTypes, getGrantsYears})(Index)